
// VideoComponent.js
import React, { useEffect }  from 'react';
import DOMPurify from 'dompurify';
import CookieOverlay  from '../CookieOverlay/CookieOverlay';

const VideoComponent = ({ videoHeadline = '', videoContent = '', backgroundColor = '', brightcoveVideoPlayerUrl = '', videoStartImage = '', dataOptanonCategory = '', cookieOverlayTitle = '', cookieOverlayDescription = '', cookiePreferencesButtonText = '', cookieOverlaySubtext = '', cookieOverlayBackgroundColor = '' }) => {

	useEffect(() => {
		window.applicationReInit(['Brightcove']);
	}, [brightcoveVideoPlayerUrl]);

	return (
		<div className={`c-CookieAware-VideoComponent u-padding-top-50 ${backgroundColor}`}>
			<div className="l-grid l-grid--max-width u-margin-bottom-20">
				{videoHeadline && (
					<div className="l-grid__row u-margin-top-none u-margin-bottom-none">
						<div className="offset-large-1 offset-medium-1 l-grid__column-large-10 l-grid__column-medium-10">
							<h2 className="c-heading  c-heading--section u-text-center"
								dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(videoHeadline) }}>
							</h2>
							{videoContent && (
								<p className="c-copy center"
									dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(videoContent) }}>
								</p>
							)}
						</div>
					</div>
				)}
			</div>
			<div className="l-grid l-grid--max-width u-padding-bottom-20">
				<div className="c-image-or-video__media cookie-disclosure is-enabled padding-bottom-none" data-optanoncategory={dataOptanonCategory}>
					<div className="c-image-or-video__image l-grid__row">
						<div className="l-grid__column-medium-8 offset-medium-2">
							<div className="c-video ">
								<div className="c-video__iframe js-brightcove" data-embed={brightcoveVideoPlayerUrl}
									data-autoplay="false"
									data-title={videoHeadline} aria-label={`${videoHeadline} - Play Video`} role="link" tabIndex="0">
									<div className="c-video__play-button" role="button"></div>
									<img src={videoStartImage} className="c-video__thumbnail" alt="" />
								</div>
							</div>

						</div>

					</div>
				</div>
				<CookieOverlay 
					cookieOverlayTitle={cookieOverlayTitle} 
					cookieOverlayDescription={cookieOverlayDescription} 
					cookiePreferencesButtonText={cookiePreferencesButtonText} 
					cookieOverlaySubtext={cookieOverlaySubtext} 
					cookieOverlayBackgroundColor={cookieOverlayBackgroundColor} 
				/>
			</div>
		</div>
	);
}

export default VideoComponent;